import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../Home.vue"),
    meta: {
      requiresAuth: true,
      class: "/",
      tableLoader: false,
      editLoader: false,
      dashboard: true,
    },
  },
];

const router = new VueRouter({
  mode: process.env.IS_ELECTRON ? "hash" : "history",
  base: process.env.BASE_URL,
  routes,
});

// function isLoggedIn() {
//   return localStorage.getItem("isLoggedIn");
// }

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (!isLoggedIn() || isLoggedIn() == null) {
//       next({
//         name: "Login",
//       });
//     } else {
//       next();
//     }
//   } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
//     if (isLoggedIn()) {
//       next({
//         name: "Home",
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
